<template>
  <section style="display:flex; flex-direction:column; height:100%;">
    <slot name="SeccionInicial" />
    <v-list
      class="py-0"
      style="border-top:1px solid white; background:none;"
    >
      <v-tooltip
        v-for="(admin, i) in opcionesPromocion"
        :key="(i+10)*10"
        right
        color="primary"
      >
        <template #activator="{ on }">
          <v-list-tile
            v-if="admin.menuParametrizadoPadreId !== null"
            :class="esRutaActual(admin.ruta, admin.menuParametrizadoId)?'horizontal-gradient':''"
            @click="go(admin.ruta, admin.menuParametrizadoId)"
            v-on="mini?on:null"
          >
            <v-list-tile-action>
              <img :src="`/iconos/${admin.icono}-blanco-negro-md.png`" alt="" width="26px" />
            </v-list-tile-action>
            <v-list-tile-title class="font-weight-regular body-1">
              {{ admin.titulo }}
            </v-list-tile-title>
          </v-list-tile>
          <v-subheader v-else>
            <small><strong>{{ admin.titulo }}</strong></small>
          </v-subheader>
        </template>
        <div class="pa-2">
          <h3>{{ admin.titulo }}</h3>
        </div>
      </v-tooltip>
    </v-list>
    <slot name="SeccionFinal" />
  </section>
</template>
<script>
import types from "@/store/types/Usuario";
import { mapActions } from "vuex";
import GlobalIconToolTip from '@/components/Global/GlobalIconToolTip.vue'
export default {
  components: {
    GlobalIconToolTip,
  },
  props: {
    mini: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    opcionesPromocion: [],
  }),
  mounted() {
    this.CargarMenus();
  },
  methods: {
    CargarMenus() {
      this.ObtenerListaMenus('1,2').then(respuesta => {
        this.opcionesPromocion = respuesta.data;
      });
    },
    ...mapActions({
      ObtenerListaMenus: types.actions.ObtenerListaMenus
    }),
    go(url,menuParametrizadoId) {
      this.$emit('emitOpcionSeleccionada')
      if (this.$enrutamiento.tieneParametro(url)){
        const codOpcionHasid = this.$libhashids.Codifica(menuParametrizadoId);
        //this.$router.push(url + "/" + codOpcionHasid); // TODO:existe un error al utilizar el push, pero redirecciona
        location.href=url + "/" + codOpcionHasid
      }
      else {
        this.$router.push(url);
      }
    },
    esRutaActual(ruta, menuParametrizadoId) {
      try {
        if(this.$route.path === ruta) {
          return true
        } else {
          if(this.$route.params.codOpcion || this.$route.path.startsWith('/Formulario')) {
            const id = this.$libhashids.Decodifica(this.$route.params.codOpcion)[0] || this.$route.path.substring(22,26)
            if(menuParametrizadoId == id) {
              return true
            }
          } else {
            return this.$route.path.includes(ruta) && ruta != '/'
          }
        }
      } catch (error) {
        return false
      }
    },
    /* dinamicoStyle(valorPadre) {
      if(valorPadre) {
        return {
          'padding-left':  '1em'
        }
      } else{
        return {
          'padding-right': '17em'
        };
      }
    } */
  },
}
</script>
<style>
.v-tooltip__content {
  opacity: 1!important;
}
.right-padding-indent {
    padding-right: 2em;
}
</style>
